
import {
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';

export function useIsOverflowing<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const checkOverflow = useCallback(() => {
    const element = ref.current;

    if (!element) return;

    setIsOverflowing(
      element.scrollWidth > element.clientWidth
    );
  }, []);

  useEffect(() => {
    const element = ref.current;

    if (!element) return;

    checkOverflow();

    const observer = new ResizeObserver(checkOverflow);
    observer.observe(element);

    return () => observer.disconnect();
  }, [checkOverflow]);

  return {
    ref,
    isOverflowing,
    checkOverflow,
  };
}